export default __webpack_public_path__ + "e2325a59da7e04a0b9875030ed368785.png";